import { useQuery } from "@tanstack/react-query";

import { fetchMe, type MeResponse } from "../api/users";

export const ME_QUERY_KEY = ["users", "me"] as const;

/** `GET /v1/users/me` — the calling user's own profile (+ effective assumptions). */
export function useMe() {
  return useQuery<MeResponse>({
    queryKey: ME_QUERY_KEY,
    queryFn: fetchMe,
    staleTime: 30_000,
  });
}
